<section class="users-page">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div>
      <h3 class="title mb-1">Brand Images</h3>
      <p class="subtitle page-desc mb-0">
        Manage dynamic image URLs shown on auth and onboarding screens.
      </p>
    </div>
  </div>

  <div
    class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-3">
    <div class="d-flex align-items-center gap-2">
      <app-search-box
        tooltipText="Search By name and message"
        [value]="searchTerm()"
      (search)="onSearch($event)"></app-search-box>
      @if (hasSelection()) {
        <button
          class="btn btn-icon btn-delete-bulk"
          (click)="deleteSelectedImages()"
          title="Delete Selected">
          <i class="pi pi-trash" style="font-size: 1.25rem"></i>
        </button>
      }
    </div>

    <div class="d-flex align-items-center gap-3 ms-auto">
      <button class="btn btn-primary" (click)="openAddModal()">
        <i class="fa-solid fa-plus me-2"></i> Add Image
      </button>
      <div
        class="d-flex align-items-center gap-2 border rounded px-1 header-icon-actions-wrapper">
        <button
          type="button"
          class="btn btn-icon p-1 header-icon-action-btn"
          (click)="fetchImages()"
          title="Refresh">
          <i
            class="pi pi-refresh"
          style="font-size: 1.25rem; color: #6b7280"></i>
        </button>
        <button
          type="button"
          class="btn btn-icon p-1 tooltip-wrap header-icon-action-btn"
          (click)="toggleIncludeDeleted()">
          <i
            class="pi pi-asterisk"
            style="font-size: 1.25rem"
          [style.color]="includeDeleted() ? '#F908B7' : '#6b7280'"></i>
          <span class="tooltip-box">Include Mark Deleted</span>
        </button>
      </div>
    </div>
  </div>

  <div class="table-container shadow">
    <table class="onboarding-table">
      <thead>
        <tr>
          <th class="checkbox-col" width="32">
            <input
              type="checkbox"
              [checked]="allSelected()"
              (change)="onToggleSelectAll()" />
            </th>
            <th>Preview</th>
            <th class="sortable" (click)="onSort('name')">
              Name
              <span
                class="sort-indicator"
                [class.active]="currentSortField() === 'name'"
                >{{ getSortIcon("name") }}</span
                >
              </th>
              <th class="sortable" (click)="onSort('age')">
                Age
                <span
                  class="sort-indicator"
                  [class.active]="currentSortField() === 'age'"
                  >{{ getSortIcon("age") }}</span
                  >
                </th>

                <th class="text-center">Message</th>

                <th class="sortable" (click)="onSort('category')">
                  Category
                  <span
                    class="sort-indicator"
                    [class.active]="currentSortField() === 'category'"
                    >{{ getSortIcon("category") }}</span
                    >
                  </th>
                  <th class="sortable" (click)="onSort('imageType')">
                    Type
                    <span
                      class="sort-indicator"
                      [class.active]="currentSortField() === 'imageType'"
                      >{{ getSortIcon("imageType") }}</span
                      >
                    </th>

                    <th class="sortable" (click)="onSort('order')">
                      Order
                      <span
                        class="sort-indicator"
                        [class.active]="currentSortField() === 'order'"
                        >{{ getSortIcon("order") }}</span
                        >
                      </th>
                      <th class="sortable" (click)="onSort('weight')">
                        Weight
                        <span
                          class="sort-indicator"
                          [class.active]="currentSortField() === 'weight'"
                          >{{ getSortIcon("weight") }}</span
                          >
                        </th>
                        <th class="sortable" (click)="onSort('status')">
                          Status
                          <span
                            class="sort-indicator"
                            [class.active]="currentSortField() === 'status'"
                            >{{ getSortIcon("status") }}</span
                            >
                          </th>

                          <th class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        @if (loading()) {
                          <tr>
                            <td colspan="100%">
                              <div class="d-flex justify-content-center py-4">
                                <app-spinner-loader [width]="35" />
                              </div>
                            </td>
                          </tr>
                        } @else if (images().length === 0) {
                          <tr>
                            <td colspan="100%" class="no-data-cell">No images found</td>
                          </tr>
                        } @else {
                          @for (img of images(); track trackById($index, img)) {
                            <tr
                              [ngClass]="{ 'deleted-row': !!img.deletedAt }"
                              [class.selected]="isSelected(img)">
                              <td class="checkbox-col">
                                <input
                                  type="checkbox"
                                  [checked]="isSelected(img)"
                                  (change)="onToggleSelect(img)" />
                                </td>
                                <td>
                                  <img
                                    [src]="img.imageUrl"
                                    [alt]="img.name"
                                    class="preview-thumb"
                                    [class.circle-thumb]="img.imageType === 'circle'"
                                    style="cursor: pointer"
                                    (click)="openPreview(img.imageUrl)"
                (error)="
                  $any($event.target).src = 'assets/images/profile.png'
                " />
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2">
                                      <span class="fw-semibold">{{ img.name }}</span>
                                    </div>
                                  </td>
                                  <td class="text-center">{{ img.age }}</td>
                                  <td class="text-center">
                                    <span class="tooltip-wrap">
                                      {{ img.message | slice: 0 : 50
                                      }}{{ (img.message || "").length > 50 ? "..." : "" }}
                                      <span class="tooltip-box">{{ img.message }}</span>
                                    </span>
                                  </td>
                                  <td class="text-center">{{ img.category }}</td>
                                  <td class="text-center">
                                    <span
                                      class="badge"
                                      [class.badge-circle]="img.imageType === 'circle'"
                                      [class.badge-square]="img.imageType === 'square'">
                                      {{ img.imageType | titlecase }}
                                    </span>
                                  </td>
                                  <td class="text-center">{{ img.order }}</td>
                                  <td class="text-center">{{ img.weight }}</td>
                                  <td class="text-center">
                                    <div class="d-flex justify-content-center">
                                      <label class="switch">
                                        <input
                                          type="checkbox"
                                          [checked]="img.isActive"
                                          (change)="toggleStatus(img)"
                                          [disabled]="!!img.deletedAt" />
                                          <span class="slider"></span>
                                        </label>
                                      </div>
                                    </td>
                                    <td class="text-center">
                                      <div class="action-buttons justify-content-center">
                                        <button
                                          class="btn btn-edit"
                                          title="Edit"
                                          (click)="openEditModal(img)"
                                          [disabled]="!!img.deletedAt">
                                          Edit
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>

                          <!-- Pagination — matches users table exactly -->
                          <div class="pagination-section">
                            <div class="pagination-info">
                              <span>
                                Showing {{ startIndex }} to {{ endIndex }} of
                                {{ totalCount() }} Entries
                              </span>
                            </div>
                            <div class="d-flex gap-2">
                              @if (images().length !== 0) {
                                <label class="page-size-label" for="obPageSizeSelect"
                                  >Page Size:</label
                                  >
                                  <select
                                    id="obPageSizeSelect"
                                    [(ngModel)]="pageSize"
                                    (ngModelChange)="onPageSizeChange($event)"
                                    class="form-select"
                                    style="width: 70px;">
                                    @for (size of pageSizes; track size) {
                                      <option [value]="size">
                                        {{ size }}
                                      </option>
                                    }
                                  </select>
                                }
                                <button
                                  class="btn btn-outline pagination-btn"
                                  [disabled]="currentPage() === 1 || loading() || images().length === 0"
                                  (click)="previousPage()">
                                  &lt; Prev
                                </button>
                                <button
                                  class="btn btn-outline pagination-btn"
                                  [disabled]="currentPage() === totalPages || loading()"
                                  (click)="nextPage()">
                                  Next &gt;
                                </button>
                              </div>
                            </div>
                          </div>
                        </section>

                        @if (isModalOpen()) {
                          <div class="modal-backdrop" (click)="closeModal()"></div>
                          <div class="modal-panel">
                            <app-onboarding-image-form
                              [editingImage]="editingImage()"
                              [isSaving]="isSaving()"
                              (saved)="onFormSaved($event)"
                              (cancelled)="closeModal()" />
                            </div>
                          }
                          @if (previewPopupUrl()) {
                            <div class="modal-backdrop" (click)="closePreview()"></div>
                            <div class="preview-modal">
                              <button class="btn-close preview-close" (click)="closePreview()"></button>
                              <img [src]="previewPopupUrl()!" alt="Preview" class="preview-modal-img" />
                            </div>
                          }
